import React from "react";
import newarkLocationImg from "../assets/images/newark-location.jpg";

function GoogleMap() {
  const address = "677 Bergen St., Newark, NJ 07108";
  const mapEmbedUrl =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.123!2d-74.2158!3d40.7242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25b7e5d5d5d5d%3A0x0!2s677%20Bergen%20St%2C%20Newark%2C%20NJ%2007108!5e0!3m2!1sen!2sus!4v1700000000";

  return (
    <section className="w-full py-16 sm:py-20 relative">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${newarkLocationImg})`,
          opacity: 0.3,
        }}
      />

      {/* Content */}
      <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            VISIT US
          </h2>
          <p className="text-lg text-gray-600">{address}</p>
        </div>

        {/* Map */}
        <div className="w-full rounded-lg overflow-hidden shadow-lg">
          <iframe
            width="100%"
            height="500"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen=""
            referrerPolicy="no-referrer-when-downgrade"
            src={mapEmbedUrl}
            title="A Plus Flavor Restaurant Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default GoogleMap;
